<script setup lang="ts">
import { RouterView } from 'vue-router'
import ToastStack from '@/components/ui/ToastStack.vue'
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue'
import ErrorBoundary from '@/components/ui/ErrorBoundary.vue'
</script>

<template>
  <ErrorBoundary>
    <!-- No route transition: motion-v AnimatePresence gated mounting on rAF,
         so pages stayed blank (/sign, /verify) or lingered 3-4 s. -->
    <RouterView />
  </ErrorBoundary>
  <ToastStack />
  <ConfirmDialog />
</template>
